export const CpDescription: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={"cpln-ant-form-item-description mb-1"}>{children}</div>;
};
